import type {BlockRendererMap} from './blocks';
import {
  textBlockConfig,
  meetingSummaryBlockConfig,
  listBlockConfig,
  documentsBlockConfig,
  scheduleMeetingBlockConfig,
  richTextBlockConfig,
  metricBlockConfig,
  chartBlockConfig,
} from './blocks';

// Safe: the map keys by block.type, guaranteeing the correct block subtype
// reaches each config's component and isEmpty at runtime.
export const BLOCK_RENDERER_MAP = {
  text: textBlockConfig,
  meeting_summary: meetingSummaryBlockConfig,
  list: listBlockConfig,
  documents: documentsBlockConfig,
  schedule_meeting: scheduleMeetingBlockConfig,
  rich_text: richTextBlockConfig,
  metric: metricBlockConfig,
  chart: chartBlockConfig,
} as unknown as BlockRendererMap;
